import { CustomersInfo } from "./customers-info";

export class UnitsRequiredBomInfo{
    unitName:string;
    children:CustomersInfo[];
    rowSpan:number;
}